(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["evelyn-story"] && !Shopify.designMode) return;
  try {
    
function initEvelynPage() {
  const story = document.querySelector('.ev-redesign');
  if (!story || story.dataset.ready) return;
  story.dataset.ready = 'true';
  const controller = new AbortController();
  const { signal } = controller;
  let formObserver;
  let stickyObserver;
  let lastTrigger;
  let dialog;
  let bundle;
  let offer = '1';
  const variants = JSON.parse(story.querySelector('[data-ev-variants]').textContent);
  const community = story.querySelector('.ev-community-motion');
  if (community) {
    const duplicate = community.firstElementChild.cloneNode(true);
    duplicate.setAttribute('aria-hidden', 'true');
    duplicate.setAttribute('inert', '');
    duplicate.querySelectorAll('[data-shopify-editor-block]').forEach(el => el.removeAttribute('data-shopify-editor-block'));
    community.append(duplicate);
  }
  const duoSelection = () => bundle ? Array.from(bundle.querySelectorAll('[data-ev-duo-item]')).map(item => variants.find(v => v.color === item.querySelector('[data-ev-duo-color]').value && v.size === item.querySelector('[data-ev-duo-size]').value)) : [];
  const updateDuo = () => {
    if (!bundle) return;
    bundle.querySelector('[data-ev-duo]').hidden = offer !== '2';
    bundle.querySelectorAll('[data-ev-duo-item]').forEach(item => {
      const color = item.querySelector('[data-ev-duo-color]').value;
      const sizes = item.querySelector('[data-ev-duo-size]');
      Array.from(sizes.options).forEach(option => { option.disabled = !variants.some(v => v.color === color && v.size === option.value && v.available); });
      if (sizes.selectedOptions[0]?.disabled) sizes.value = Array.from(sizes.options).find(option => !option.disabled)?.value || '';
    });
    const selected = duoSelection();
    let available = selected.length === 2 && selected.every(v => v?.available);
    if (available && selected[0].id === selected[1].id && selected[0].tracked && selected[0].policy !== 'continue' && selected[0].quantity < 2) available = false;
    const stock = bundle.querySelector('[data-ev-duo-stock]');
    const text = available ? 'Both selections available · Free delivery' : 'This combination is unavailable. Choose another color or size.';
    if (stock.textContent !== text) stock.textContent = text;
    stock.dataset.available = String(available);
  };
  const details = document.querySelector('.product-details');
  if (!details) return;
  details.id = 'ev-choose';
  const selection = () => Array.from(details.querySelectorAll('variant-picker input:checked')).map(input => input.value).join(' / ');
  const updateSelection = () => {
    updateDuo();
    details.dataset.evOffer = offer;
    const value = offer === '2' ? duoSelection().map((v,i) => 'Set '+(i+1)+': '+(v ? v.color+' / '+v.size : 'Choose a size')).join(' · ') : selection();
    story.querySelectorAll('[data-ev-sticky-selection]').forEach(el => { if (el.textContent !== value) el.textContent = value; });
    if (dialog) { const el = dialog.querySelector('[data-ev-selection]'); const text = value + (offer === '2' ? ' · 2 matching sets' : ' · 1 matching set'); if (el.textContent !== text) el.textContent = text; }
    if (dialog) {
      dialog.dataset.offer = offer;
      const values = {'[data-ev-summary-label]': offer === '2' ? 'Two Girly Sets' : 'Girly Set', '[data-ev-subtotal]': offer === '2' ? '439 DH' : '219 DH', '[data-ev-shipping]': offer === '2' ? 'Free' : '30 DH', '[data-ev-total]': offer === '2' ? '439 DH' : '249 DH'};
      for (const [selector, text] of Object.entries(values)) { const el = dialog.querySelector(selector); if (el.textContent !== text) el.textContent = text; }
      dialog.querySelector('[data-ev-modal-note]').hidden = offer !== '2';
      dialog.querySelectorAll('button[type="submit"], .leadform-button').forEach(button => { if (offer === '2') { if (!button.hasAttribute('data-ev-offer-disabled')) button.dataset.evOfferDisabled = String(button.disabled); button.disabled = true; } else if (button.hasAttribute('data-ev-offer-disabled')) { button.disabled = button.dataset.evOfferDisabled === 'true'; delete button.dataset.evOfferDisabled; } });
    }
    if (bundle) bundle.querySelector('[data-ev-offer-note]').hidden = offer !== '2';
    const cartButton = details.querySelector('[data-ev-cart]');
    if (cartButton) cartButton.disabled = offer === '2';
  };
  const enhanceForm = () => {
    const form = details.querySelector('#leadform-embedded-container');
    if (!form || form.closest('dialog')) return;
    const trigger = story.querySelector('[data-ev-order-template]').content.firstElementChild.cloneNode(true);
    trigger.classList.add('ev-order-trigger');
    details.querySelectorAll('.ev-action-stack, .ev-bundle-wrap').forEach(el => el.remove());
    const newDialog = story.querySelector('[data-ev-modal-template]').content.firstElementChild.cloneNode(true);
    const picker = details.querySelector('variant-picker');
    if (picker) picker.after(trigger); else form.before(trigger);
    bundle = story.querySelector('[data-ev-bundle-template]').content.firstElementChild.cloneNode(true);
    trigger.after(bundle);
    const videos = story.querySelector('[data-ev-video-template]');
    const benefits = story.querySelector('[data-ev-benefits-template]');
    if (benefits) bundle.querySelector('[data-ev-benefits-slot]').append(benefits.content.cloneNode(true));
    if (videos) {
      bundle.querySelector('[data-ev-video-slot]').append(videos.content.cloneNode(true));
      const region = bundle.querySelector('.ev-motion-videos');
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const clips = region.querySelectorAll('video');
      const loadClips = () => clips.forEach(async video => {
        try {
          if (video.dataset.evVideoModule && !video.src) {
            const clip = await import(new URL(video.dataset.evVideoModule, document.baseURI).href);
            if (!video.isConnected || signal.aborted) return;
            video.src = clip.default;
            video.muted = true;
          }
          if (!region.classList.contains('is-paused')) await video.play();
        } catch (error) { console.warn('Evelyn motion clip:', error.message); video.closest('.evelyn-story__video').classList.add('ev-video-unavailable'); }
      });
      region.evLoadClips = loadClips;
      if (reducedMotion) {
        region.classList.add('is-paused');
        const pause = region.querySelector('[data-ev-video-pause]');
        pause.setAttribute('aria-pressed', 'true');
        pause.textContent = 'Play motion';
        clips.forEach(video => { video.removeAttribute('autoplay'); video.pause(); });
      } else {
        const observer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          observer.disconnect();
          loadClips();
        }, {rootMargin:'250px'});
        observer.observe(region);
        signal.addEventListener('abort', () => observer.disconnect(), {once:true});
      }
    }
    bundle.addEventListener('change', event => { if (event.target.name === 'evelyn-offer') offer = event.target.value; updateSelection(); }, {signal});
    bundle.querySelectorAll('[name="evelyn-offer"]').forEach(input => input.checked = input.value === offer);
    details.append(newDialog);
    newDialog.querySelector('[data-ev-form-slot]').append(form);
    if (dialog && dialog !== newDialog) dialog.remove();
    dialog = newDialog;
    details.classList.add('ev-order-enhanced');
    updateSelection();
    if (stickyObserver) stickyObserver.disconnect();
    stickyObserver = new IntersectionObserver(entries => {
      const rect = entries[0].boundingClientRect;
      story.querySelector('.ev-sticky-order').dataset.visible = String(!entries[0].isIntersecting && rect.top < 0);
    }, {threshold:0});
    stickyObserver.observe(trigger);
  };
  story.querySelectorAll('[data-ev-color]').forEach(button => button.addEventListener('click', () => {
    const input = Array.from(details.querySelectorAll('variant-picker input')).find(input => input.value === button.dataset.evColor);
    if (input && !input.disabled) input.click();
    details.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
  }, {signal}));
  document.addEventListener('click', event => {
    const cartTrigger = event.target.closest('[data-ev-cart]');
    if (cartTrigger && offer === '1') { const nativeCart = details.querySelector('.add-to-cart-button'); if (nativeCart && !nativeCart.disabled) nativeCart.click(); }
    const benefitDirection = event.target.closest('[data-ev-benefit-direction]');
    if (benefitDirection) { const track = benefitDirection.closest('.ev-benefits-wrap').querySelector('.ev-benefits-carousel'); const direction = Number(benefitDirection.dataset.evBenefitDirection); const end = track.scrollWidth - track.clientWidth; const next = track.scrollLeft + direction * (track.firstElementChild.offsetWidth + 12); track.scrollTo({left: next > end + 20 ? 0 : next < -20 ? end : next, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'}); }
    const galleryPause = event.target.closest('[data-ev-community-pause]');
    if (galleryPause) { const paused = galleryPause.getAttribute('aria-pressed') !== 'true'; galleryPause.setAttribute('aria-pressed', String(paused)); galleryPause.textContent = paused ? 'Resume gallery' : 'Pause gallery'; story.querySelector('.ev-community-motion')?.classList.toggle('is-paused', paused); }
    const pause = event.target.closest('[data-ev-video-pause]');
    if (pause) { const paused = pause.getAttribute('aria-pressed') !== 'true'; pause.setAttribute('aria-pressed', String(paused)); pause.textContent = paused ? 'Resume motion' : 'Pause motion'; const region = pause.closest('.ev-motion-videos'); region.classList.toggle('is-paused', paused); if (!paused) region.evLoadClips?.(); region.querySelectorAll('video').forEach(video => paused ? video.pause() : video.play().catch(() => {})); }
    const trigger = event.target.closest('[data-ev-order]');
    if (trigger && dialog && dialog.isConnected) {
      lastTrigger = trigger;
      updateSelection();
      dialog.showModal();
    } else if (event.target.closest('[data-ev-close]') && dialog) {
      dialog.close();
      if (lastTrigger?.isConnected) lastTrigger.focus();
    }
    if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
  }, {signal});
  details.addEventListener('change', updateSelection, {signal});
  enhanceForm();
  formObserver = new MutationObserver(() => { enhanceForm(); updateSelection(); });
  formObserver.observe(details, {childList:true,subtree:true});
  document.addEventListener('shopify:section:unload', event => {
    if (!event.target.contains(story)) return;
    controller.abort();
    formObserver.disconnect();
    stickyObserver?.disconnect();
  }, {signal});
}
initEvelynPage();
document.addEventListener('shopify:section:load', initEvelynPage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
